module.exports = __webpack_public_path__ + "static/img/6.02789c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/pengu/6.png
// module id = Y60c
// module chunks = 35